// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__CJbAG","fileBtn":"File_fileBtn__14rE5","closeBtn":"File_closeBtn__24fyl","fileSelected":"File_fileSelected__3UWr-","disabled":"File_disabled__2aYy1"};